import { useTheme } from '@mui/material';
import { SlideoutDrawer } from '#components/SlideoutDrawer/index.tsx';
import { Ancestor } from '#enums/ancestors.ts';
import { SeasonsAndEpisodes } from './SeasonsAndEpisodes.tsx';
import { type SeasonData } from './types.ts';

export type EpisodesDrawerProps = {
  items: SeasonData[];
  onEpisodeClick: (season: number, episode: number) => void;
  open: boolean;
  selectedEpisodeNumber: number;
  selectedSeasonNumber: number;
  setOpen: (value: boolean) => void;
};

export const EpisodesDrawer = ({
  items,
  onEpisodeClick,
  open,
  selectedEpisodeNumber,
  selectedSeasonNumber,
  setOpen,
}: EpisodesDrawerProps) => {
  const theme = useTheme();

  return (
    <SlideoutDrawer
      ancestor={Ancestor.Playlist}
      anchor="left"
      containerSx={{ overflow: 'hidden' }}
      headerIcon="close"
      open={open}
      setOpen={setOpen}
      sx={{
        '.MuiDrawer-paper': {
          [theme.breakpoints.up('md')]: {
            width: '75%',
          },
          [theme.breakpoints.up('lg')]: {
            width: '50%',
          },
          [theme.breakpoints.up('xl')]: {
            width: '50%',
          },
        },
        'z-index': 1300,
      }}
      title="Episodes"
    >
      <SeasonsAndEpisodes
        onEpisodeClick={onEpisodeClick}
        seasons={items}
        selectedEpisodeNumber={selectedEpisodeNumber}
        selectedSeasonNumber={selectedSeasonNumber}
      />
    </SlideoutDrawer>
  );
};
